import { getConfig } from '@/config';
import { formatRequestParams } from '@/search-for-retail/evaluate/search/search.formatters';
import { searchApi } from './searchApi';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for evaluate-specific search operations.
 *
 * The evaluate `getSearchResults` uses `formatRequestParams` to transform
 * `SearchRequestParams` (with `page`) into the DTO shape expected by the API
 * (`skip`, `refinements`, etc.).
 *
 * Auth headers are injected per-request because `clientKey` is dynamic
 * (per-area/per-collection) and not available at API creation time.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const evaluateSearchApi = searchApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Executes an evaluate search request against the base Search API URL.
         *
         * Uses `formatRequestParams` to convert `SearchRequestParams` (which
         * includes `page`) into the API-compatible DTO (which uses `skip`).
         *
         * @endpoint POST /
         * @returns Search
         */
        getEvaluateSearchResults: builder.query({
            query: ({ clientKey, requestParams }) => ({
                url: getConfig().searchApiUrl,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `client-key ${clientKey}`,
                },
                body: formatRequestParams(requestParams),
            }),
        }),
    }),
});
export const { useLazyGetEvaluateSearchResultsQuery } = evaluateSearchApi;
